import { useMutation } from "@tanstack/react-query";
import { contactService } from "./contact.service";
import { CreateContactMessageRequest } from "./contact.model";

export function useSubmitContactMessage() {
  return useMutation({
    mutationFn: (data: CreateContactMessageRequest) =>
      contactService.submitContactMessage(data),
  });
}
